module.exports = __webpack_public_path__ + "img/nutrilon-prev-care.d4942533.jpg";